export default "__VITE_ASSET__BSPEjT5w__"